<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :fixed-header="true"
      :search="search"
      height="calc(100vh - 275px)"
      class="font-resp-tabela"
      :show-expand="true"
      :single-expand="true"
      item-key="id_sistema"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title class="ml-n3">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Relações entre Sistemas e Aplicativos
          </v-toolbar-title>

          <v-divider class="mx-5" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            class="mr-6"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            style="max-width: 450px"
          ></v-text-field>
          <v-btn color="primary" dark @click="dialog = true">Novo</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.qtde_apps="{ item }">
        {{ item.aplicativos.length }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <h3 style="padding: 15px; padding-top: 25px">
            Aplicativos do Sistema {{ item.sigla_desc }}
          </h3>
          <v-simple-table class="mb-10">
            <template v-slot:default>
              <thead>
                <tr style="color: #555">
                  <th>Código</th>
                  <th>Descrição Aplicativo</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="app in item.aplicativos" :key="app.id_aplicativo">
                  <td>{{ app.id_aplicativo }}</td>
                  <td>{{ app.descricao_aplicativo }}</td>
                  <td>
                    <v-icon
                      :title="'Editar Aplicativos de ' + item.sigla"
                      class="mr-2"
                      @click="editarItem(app)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      :title="'Excluir Aplicativo de ' + item.sigla"
                      class="mr-2"
                      @click="deleteItem(app)"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <div class="title-dialog">
          <v-btn icon dark @click="fecharDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <p>Sistemas e Aplicativos</p>
        </div>
        <v-card-text class="pt-5">
          <v-layout>
            <v-flex xs8>
              <h2 id="descricao-lista">
                <v-icon>mdi-format-list-text</v-icon> LISTA DE APLICATIVOS
              </h2>
            </v-flex>
            <v-flex xs4>
              <v-autocomplete
                v-model="editedItem.id_sistema"
                :items="selects.sistemasIntegracao.items"
                label="Selecione um Sistema"
                item-text="sigla_desc"
                item-value="id"
                clearable
                outlined
                @change="buscarAplicativosRelatorios()"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-expansion-panels
            v-model="moduloApp"
            accordion
            multiple
            class="mb-10"
          >
            <v-expansion-panel>
              <v-expansion-panel-header color="#F0F0F0">
                <div class="titulo-painel">
                  <v-icon>mdi-file</v-icon>
                  <span>Relatórios</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  v-for="(item, i) in selects.apps.items"
                  :key="i"
                  class="aplicativos"
                >
                  <span>{{ item.descricao_aplicativo }}</span>
                  <v-spacer></v-spacer>
                  <v-switch
                    class="mr-5"
                    v-model="item.cadastrado"
                    :label="item.cadastrado ? 'Ativado' : 'Desativado'"
                    :disabled="editedItem.id_sistema > 0 ? false : true"
                    @change="save(item.idaplicativo)"
                  ></v-switch>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfigApi from "./../../api/cfg";

export default {
  data: () => ({
    search: "",
    dialog: false,
    moduloApp: [],

    editedIndex: -1,
    editedItem: {
      id_sistema: "",
    },

    headers: [
      { text: "Código", value: "id_sistema" },
      { text: "Descrição Sistema", value: "descricao" },
      { text: "Sigla", value: "sigla" },
      { text: "Qtde. Aplicativos", value: "qtde_apps", align: "center" },
      { text: "Expandir", value: "data-table-expand", sortable: false },
    ],
    desserts: [],

    selects: {
      apps: {
        items: [],
      },
      sistemasIntegracao: {
        items: [],
      },
    },
  }),

  created() {
    this.buscarSistemasAplicativos();
    this.buscarSistemasIntegracao();
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Novo Relação Sistema e Aplicativo"
        : "Editar Relação Sistema e Aplicativo";
    },
  },

  watch: {
    dialog() {
      if (this.dialog) {
        this.selects.apps.items.forEach((item) => {
          item.cadastrado = false;
        });
      }
    },
  },

  methods: {
    editarItem(app) {
      this.dialog = true;
      this.editedItem.id_sistema = app.id_sistema;
      this.buscarAplicativosRelatorios();
    },

    buscarAplicativosRelatorios() {
      if (this.editedItem.id_sistema > 0) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = { id_sistema: this.editedItem.id_sistema };

        this.$store.dispatch(
          "loading/addRequisicao",
          ConfigApi.getAplicativosRelatorios(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.selects.apps.items = response.data.aplicativos;
              this.moduloApp = [0];
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      } else {
        this.selects.apps.items = [];
        this.moduloApp = [];
      }
    },

    buscarSistemasIntegracao() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        ConfigApi.getSistemasIntegracao(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.selects.sistemasIntegracao.items = response.data.sistemas;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarSistemasAplicativos() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        ConfigApi.getSistemasAplicativos(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.desserts = response.data.sistemas_apps;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    save(idaplicativo) {
      if (this.editedItem.id_sistema > 0 && idaplicativo > 0) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          id_sistema: this.editedItem.id_sistema,
          id_aplicativo: idaplicativo,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          ConfigApi.addSistemasAplicativos(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.buscarSistemasAplicativos();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    deleteItem(item) {
      if (confirm("Deseja Realmente Excluir este Item")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          id_sistema: item.id_sistema,
          id_aplicativo: item.id_aplicativo,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          ConfigApi.deleteSistemasAplicativos(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.buscarSistemasAplicativos();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    fecharDialog() {
      this.dialog = false;
      this.editedItem = {};
      this.moduloApp = [];
      this.selects.apps.items = [];
    },
  },
};
</script>

<style scoped>
.aplicativos {
  margin-left: -25px;
  margin-right: -25px;
  height: 65px;
  font-size: 12pt;
  padding-left: 90px;
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.aplicativos:hover {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background: #f5f5f5;
}

.aplicativos span {
  margin-top: 20px;
}

#descricao-lista {
  margin-top: 10px;
  color: #444;
}

.title-dialog {
  background: #042333;
  padding: 13px;
}
.title-dialog p {
  margin-top: -32px;
  margin-left: 75px;
  margin-bottom: 5px;
  color: #fff;
  font-size: 15pt;
}
</style>
